import { render, staticRenderFns } from "./DHL.vue?vue&type=template&id=6a968a89&scoped=true"
import script from "./DHL.vue?vue&type=script&lang=js"
export * from "./DHL.vue?vue&type=script&lang=js"
import style0 from "./DHL.vue?vue&type=style&index=0&id=6a968a89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a968a89",
  null
  
)

export default component.exports